import { Table } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import Button from "../../../components/Button";
import Page from "../../../components/Page";
import NewEducation from "./NewEducation";
import Delete from "../../../assets/delete.svg";
import edit from "../../../assets/edit.svg";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import { backendUrl } from "../../../constants";
import { showNotification } from "@mantine/notifications";

const Index = ({ educationInfo, setRefetch }) => {
  const navigate = useNavigate();
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [editData, setEditData] = useState();
  const [isEdit, setIsEdit] = useState(false);


  const deleteEducation = async (id) => {
    const data = {
      userId: createdBy.id,
      educationId: id,
    };
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    await fetch(`${backendUrl}user/deleteJobSeekerEducation`, options)
      .then((response) => response.json())
      .then((response) => {
        showNotification({
          message: "Education Deleted Successfully",
          color: "green",
        });
        // setOpened(false);
        setRefetch((v) => !v);
      })
      .catch((err) => console.error(err));
  };

  const editEducation = (id, data) => {
    setShowModal(true);
    setEditId(id);
    setEditData(data);
  };

  const rows =
    educationInfo &&
    educationInfo.map((element) => (
      <tr key={element?.id}>
        <td>{element?.school}</td>
        <td>{element?.state}</td>
        <td>{element?.major}</td>
        <td>{element?.GPA}</td>
        <td className="d-flex gap-2 align-items-center">
          <img
            // onClick={() => deleteLocation(element.value)}
            src={Delete}
            width="20px"
            className="delete"
            alt="delete"
            onClick={() => deleteEducation(element.id)}
          />
          <img
            onClick={() => {
              editEducation(element.id, element.data);
              setIsEdit(true);
            }}
            src={edit}
            width="20px"
            className="delete"
            alt="edit"
          />
        </td>
      </tr>
    ));

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="location-main">
        <h2 className="text-dark text-center">Education</h2>
        <Button
          title="Add Education"
          primary={true}
          width="180px"
          style={{ marginLeft: "auto" }}
          onClick={() => setShowModal(true)}
        />
        <Table>
          <thead>
            <tr>
              <th>School Name</th>
              <th>State</th>
              <th>Major</th>
              <th>GPA</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
        <NewEducation
          opened={showModal}
          setOpened={setShowModal}
          setRefetch={setRefetch}
          editId={editId}
          editData={editData}
          setEditId={setEditId}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
